import { defineComponent as _defineComponent } from 'vue'
import OptimizerIcon from '@sh/components/Utils/OptimizerIcon.ts.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountsFooter.ts',
  props: {
  trafficSourceAccountsLength: Number,
},
  setup(__props) {



return { __sfc: true,OptimizerIcon }
}

})